// Flavour picker showcase: swipe to rotate. Arrows, side taps and the swatch list already
// rotate through radios + labels with no script; this only adds the horizontal swipe.
(() => {
  document.querySelectorAll('.flavour-picker--showcase .flavour-group').forEach((group) => {
    let x0 = null;
    let y0 = 0;
    group.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;
      x0 = e.clientX;
      y0 = e.clientY;
    });
    group.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      const dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      const radios = [...group.querySelectorAll('.flavour-tile__radio')];
      if (radios.length < 2) return;
      const i = Math.max(0, radios.findIndex((r) => r.checked));
      const next = radios[(i + (dx < 0 ? 1 : -1) + radios.length) % radios.length];
      next.checked = true;
      next.dispatchEvent(new Event('change', { bubbles: true }));
    });
    group.addEventListener('pointercancel', () => { x0 = null; });
  });
})();
